import { forEach } from 'lodash';
import Types, { GlobalState } from '../../models/action/core.d';
import { ISetMadlenActivityData, ISetMadlenUrl, ISetPendingAndSentData } from '../../models/action/madlenIntegration';
import * as Actions from '../constants/madlenIntegration';
import { IMadlenActivityData } from '../../models/components/madlen-integrations';

const MadlenIntegrationReducer = (state = GlobalState().madlenIntegration, action: Types.IAction) => {
    if (!state) {
        return state;
    }

    const newState: any = { ...state };
    if (action.type === Actions.actions.MADLEN_INTEGRATION_SET_LIST) {
        const madlenPageAction = action as ISetMadlenActivityData;
        const results = madlenPageAction.results || [];
        newState.activityData.results = results;
    } else if (action.type === Actions.actions.MADLEN_INTEGRATION_SET_CONTENTS) {
        const madlenPageAction = action as ISetPendingAndSentData;

        const results = madlenPageAction.results || [];
        const filters = madlenPageAction.filters || {};

        const updatedResults = results.map((resultItem) => {

            const matchingActivity = (state.activityData.results as Array<IMadlenActivityData>).find(
                (activity) => activity.activityId === resultItem.activityId
            );

            if (matchingActivity) {
                return {
                    ...resultItem,
                    activityType: matchingActivity.activityType,
                    termWeekId: matchingActivity.termWeekId,
                    learningOutcomeId: matchingActivity.learningOutcomeId,
                    learningOutcomeValue: matchingActivity.learningOutcomeValue,
                };
            }

            return resultItem;
        });

        if (madlenPageAction.status === 0) {
            newState.inProcessActivities = {
                filters,
                results: updatedResults
            };
        } else {
            newState.sentMadlenActivities = {
                filters,
                results: updatedResults
            };
        }

    } else if (action.type === Actions.actions.MADLEN_INTEGRATION_SET_MADLEN_URL) {
        const madlenPageAction = action as ISetMadlenUrl;
        const resultUrl = madlenPageAction.resultUrl || '';
        newState.madlenUrl = resultUrl;
    }
    return Object.assign({}, state, newState);
};

export default MadlenIntegrationReducer;
